// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"a98c55c8","215":"cb4a326d","221":"fb24b527","224":"cb4a326d","345":"18923b42","621":"bc3ec0e2","641":"75b4bedb","843":"a23bf621","896":"7847b22b"}[chunkId] + ".chunk.css";
};